var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcbLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "200 350 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 208.56,
    y1: -15960.83,
    x2: 264.17,
    y2: -15960.83,
    gradientTransform: "translate(0 -15540) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b224a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15559b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 269.8,
    y1: -15960.83,
    x2: 325.43,
    y2: -15960.83,
    gradientTransform: "translate(0 -15540) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45151e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0182f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 331.06,
    y1: -15960.83,
    x2: 386.7,
    y2: -15960.83,
    gradientTransform: "translate(0 -15540) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13582f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e9c36"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M230.8,353.71c-12.25,0-22.24,10.02-22.24,22.24v112.01h33.37c12.24,0,22.25-10.02,22.25-22.25v-112h-33.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.06,353.71c-12.24,0-22.26,10.02-22.26,22.24v112.01h33.4c12.2,0,22.23-10.02,22.23-22.25v-112h-33.37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.32,353.71c-12.23,0-22.26,10.02-22.26,22.24v112.01h33.38c12.25,0,22.26-10.02,22.26-22.25v-112h-33.38Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.29,421.23c4.7,0,9.72-4.56,9.72-10.17s-2.97-11.24-13.69-11.24h-34.25v42.84h35.75c10.7,0,13.68-5.62,13.68-11.24s-6.5-10.19-11.2-10.19ZM356.24,434.18h-12.95v-9.99h12.95s4.46.22,4.46,4.99-4.46,5-4.46,5ZM356.24,417.4h-12.95v-9.99h12.95s4.46.2,4.46,4.99-4.46,5-4.46,5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.8,406.11v30.14c5.06,5.07,15.97,7.54,25.6,7.54,13.08,0,22.78-3.01,22.78-3.01v-9.58s-8.03,5.37-19.08,5.37-16.42-7.02-16.42-15.4,5.37-15.4,16.42-15.4,19.08,5.36,19.08,5.36v-9.56s-9.7-3.01-22.78-3.01c-9.63,0-20.54,2.48-25.6,7.54Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239,424.19c0,8.71-4.51,12.72-12.88,12.72s-16.74-5.02-16.74-5.02h-.82v9c8.37,3.98,16.02,3.73,23.93,3.73,8.7,0,18.74-3.35,20.76-5.36,2-2.02,5.02-5.37,5.02-11.39v-28.79h-19.26v25.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbLogo);
export default __webpack_public_path__ + "static/media/jcb_logo.8717c8e3f79d4b2993b82bd1f3be6cd0.svg";
export { ForwardRef as ReactComponent };